import { format, parse } from 'date-fns';
import { de } from 'date-fns/locale';

export type AnalysisGranularity = 'YEAR' | 'MONTH' | 'WEEK' | 'DAY';

export const getInterval = (value: string, granularity: AnalysisGranularity) => {
  switch (granularity) {
    case 'YEAR': {
      const [date] = value.split(' ');
      return date?.endsWith('-01') ?? false;
    }
    case 'MONTH':
      return true;
    case 'WEEK':
      return value.endsWith('12:00');
    case 'DAY':
      return value.endsWith(':00');
  }
};

export const getXLabel = (value: string, granularity: AnalysisGranularity) => {
  const date = parse(value, 'yyyy-MM-dd HH:mm', new Date());
  switch (granularity) {
    case 'YEAR':
      return format(date, 'MMM', { locale: de });
    case 'MONTH':
      return format(date, 'dd', { locale: de });
    case 'WEEK':
      return format(date, 'cccccc d MMM', { locale: de });
    case 'DAY':
      return format(date, 'HH:mm', { locale: de });
  }
};
